import { render, staticRenderFns } from "./oldDistributionBill.vue?vue&type=template&id=e0dad27a&scoped=true&"
import script from "./oldDistributionBill.vue?vue&type=script&lang=js&"
export * from "./oldDistributionBill.vue?vue&type=script&lang=js&"
import style0 from "./oldDistributionBill.vue?vue&type=style&index=0&id=e0dad27a&lang=scss&scoped=true&"
import style1 from "./oldDistributionBill.vue?vue&type=style&index=1&id=e0dad27a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dad27a",
  null
  
)

component.options.__file = "oldDistributionBill.vue"
export default component.exports